<template>
  <div>
    <div ref="finalResult" id="final-result" :class="className" v-if="finished" class="mb-4">
      <h3 class="text-center">ტესტი დამთავრებულია</h3>
      <p class="text-center font-22px mb-2">თქვენი ქულა: {{ score }}/{{(total )}}</p>
    </div>
    <div v-if="className == 'fixed'" :style="{ height: `${spacerHeight}px` }"></div>
  </div>
</template>

<script>
export default {
  props: ['finished', 'score', 'total'],
  data() {
    return {
      className: '',
      spacerHeight: 0,
    };
  },
  methods: {
    addClassOnScroll: function () {
      if (window.scrollY >= 380) {
        this.className = 'fixed';
        this.spacerHeight = this.$refs.finalResult && this.$refs.finalResult.offsetHeight;
      } else {
        this.className = '';
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.addClassOnScroll);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.addClassOnScroll);
  },
};
</script>

<style lang="scss">
#final-result {
  &.fixed {
    background-color: #fafaff;
    position: fixed;
    top: 0;
    width: 100%;
    left: 0;
    z-index: 1000;
    padding-top: 15px;
    padding-bottom: 15px;
    &::after {
      content: '';
      //   /* border: 1px solid red; */
    }
  }
}
</style>
